<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Тарифы</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="tarifnyj-plan-dlya-kazhdogo"
            class="typography__headline2"
          >
            Тарифный план для каждого
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>В&nbsp;MyDonut всего шесть тарифов. Любой бизнес сможет подобрать подходящий для себя.</p>

            <p>
              Для самых больших представителей предусмотрен тариф Enterprise с&nbsp;договорными лимитами
              и&nbsp;разработкой уникальных решений и&nbsp;интеграций.
            </p>
          </div>

          <BaseLink
            class="base-button-big main-base-button-four"
            :href="createAppLink('/?modal=modal-auth-registration', 'main')"
            rel="noopener noreferrer"
            target="_blank"
          >
            Попробовать бесплатно
          </BaseLink>
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="funktsii-tarifov"
            class="typography__headline2"
          >
            Функции тарифов
          </FaqArticlesBlockHeading>
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="populyarnye-voprosy"
            class="typography__headline2"
          >
            Популярные вопросы
          </FaqArticlesBlockHeading>

          <RateQuestions />
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);
const { createAppLink } = useAppLink();

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Основная информация",
    url: "/faq/categories/osnovnaya-informatsiya",
  },
  {
    name: "Тарифы",
  },
];

const menu = [
  {
    name: "Тарифный план для каждого",
    url: "tarifnyj-plan-dlya-kazhdogo",
  },
  {
    name: "Функции тарифов",
    url: "funktsii-tarifov",
  },
  {
    name: "Популярные вопросы",
    url: "populyarnye-voprosy",
  },
];

const relatedArticles = [
  {
    name: "Что такое MyDonut",
    slug: "сhto-takoye-donut",
  },
  {
    name: "Регистрация и&nbsp;начало работы",
    slug: "registratsiya-i-nachalo-raboty",
  },
  {
    name: "Контакты",
    slug: "kontakty",
  },
];

useSeoMeta({
  title: "Тарифы",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

:deep(.content .item__description) {
  color: var(--grey-1-5);
}

:deep(.content .list) {
  column-gap: 24px;
}

@media (--md) {
  :deep(.content .list) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 32px;
  }
}

:deep(.content .table__header th) {
  font-weight: 500;
  font-size: 24px;
}

:deep(.content .questions__list) {
  list-style-type: none;
}

:deep(.content .questions-item__title) {
  color: var(--grey-1);
}
</style>
